export default "__VITE_ASSET__BM$nAPoD__"